// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rWMMVXTP6UFFG8iz7F9g9","view":"_2lahfJOv3LD5AOjdUMC6wE"};